import { render, staticRenderFns } from "./Olp.vue?vue&type=template&id=1ec4562c&scoped=true&"
import script from "./Olp.vue?vue&type=script&lang=js&"
export * from "./Olp.vue?vue&type=script&lang=js&"
import style0 from "./Olp.vue?vue&type=style&index=0&id=1ec4562c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec4562c",
  null
  
)

export default component.exports